/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_EditedInputs */

const en_views_edited = /** @type {(inputs: Views_EditedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edited`)
};

const de_views_edited = /** @type {(inputs: Views_EditedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geändert`)
};

/**
* | output |
* | --- |
* | "Edited" |
*
* @param {Views_EditedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_edited = /** @type {((inputs?: Views_EditedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_EditedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_edited(inputs)
	return en_views_edited(inputs)
});